/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteGoogleDriveProjectFileLinkInput = {
    id?: string | null | undefined;
    projectId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteGoogleDriveProjectFileLinkMutationVariables = {
    input: DeleteGoogleDriveProjectFileLinkInput;
};
export type deleteGoogleDriveProjectFileLinkMutationResponse = {
    readonly deleteGoogleDriveProjectFileLink: {
        readonly deletedGoogleDriveFileId: string | null;
    } | null;
};
export type deleteGoogleDriveProjectFileLinkMutation = {
    readonly response: deleteGoogleDriveProjectFileLinkMutationResponse;
    readonly variables: deleteGoogleDriveProjectFileLinkMutationVariables;
};



/*
mutation deleteGoogleDriveProjectFileLinkMutation(
  $input: DeleteGoogleDriveProjectFileLinkInput!
) {
  deleteGoogleDriveProjectFileLink(input: $input) {
    deletedGoogleDriveFileId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteGoogleDriveProjectFileLinkInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGoogleDriveProjectFileLinkPayload",
    "kind": "LinkedField",
    "name": "deleteGoogleDriveProjectFileLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedGoogleDriveFileId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteGoogleDriveProjectFileLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteGoogleDriveProjectFileLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteGoogleDriveProjectFileLinkMutation",
    "operationKind": "mutation",
    "text": "mutation deleteGoogleDriveProjectFileLinkMutation(\n  $input: DeleteGoogleDriveProjectFileLinkInput!\n) {\n  deleteGoogleDriveProjectFileLink(input: $input) {\n    deletedGoogleDriveFileId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'e50e749aad6b9358b5d072cb415a82ac';
export default node;
